import React, { Component } from 'react';
import Asset from '../global/Asset';

import { getContainerStyles } from '../../../../utils/Utils';

export default class CollectionHero extends Component {
  render() {
    const {
      anchor,
      backgroundColor,
      images: [image],
      header,
      subHeader,
      copy,
      textColor,
    } = this.props;
    return (
      <div id={anchor || undefined} className="collection-hero">
        <div
          className="collection-hero__wrapper"
          style={getContainerStyles(backgroundColor, textColor)}
        >
          <div className="collection-hero__background">
            {image && (
              <Asset
                asset={image}
              />
            )}
          </div>
          <div className="collection-hero__details">
            <h2 className="collection-hero__header h2">{header}</h2>
            <h3 className="collection-hero__subheader h4">{subHeader}</h3>
            <div className="collection-hero__copy">{copy}</div>
          </div>
        </div>
      </div>
    );
  }
}
